import React, { useState, useEffect } from 'react';
import moment from 'moment';

//returns 0 for "closed", 
//1 for (East Only) Blast Surf Tube, 
//2 for (full park) both main blast surf tube wave
//3 for (no tube) both main, blast, surf, wave
//4 blast and surf
//5 blast only
//Based on NB calendar for 2026
export const chooseMap = (tdate) => {

    var day = moment(tdate);

    const areaData = {
        dateRanges: [
            { start: "2026-05-02", end: "2026-05-03", value: 2 },
            { start: "2026-05-08", end: null, value: 4 },
            { start: "2026-05-09", end: "2026-05-10", value: 2 },
            { start: "2026-05-14", end: "2026-05-15", value: 4 },
            { start: "2026-05-16", end: "2026-05-17", value: 2 },
            { start: "2026-05-21", end: "2026-05-22", value: 4 },
            { start: "2026-05-23", end: "2026-08-09", value: 2 },
            { start: "2026-08-10", end: "2026-08-14", value: 4 },
            { start: "2026-08-15", end: "2026-08-16", value: 2 },
            { start: "2026-08-22", end: "2026-08-23", value: 2 },
            { start: "2026-08-29", end: "2026-08-30", value: 2 }
        ],
        defaultBefore: "2026-05-02",
        defaultAfter: "2026-08-30"
    };

    if (day.isBefore(areaData.defaultBefore) || day.isAfter(areaData.defaultAfter)) {
        return 0;
    }

    for (const range of areaData.dateRanges) {
        const startDate = moment(range.start);
        const endDate = range.end ? moment(range.end) : startDate;

        if (day.isBetween(startDate, endDate, undefined, '[]')) {
            return range.value;
        }
    }

    return 0;
};


export const renderOptions = (areaSelect, lockerAreas) => {
    let options = [];
    switch (areaSelect) {
        case 5:
            options.push(lockerAreas[1]);
            break;
        case 4:
            options.push(lockerAreas[1], lockerAreas[2]);
            break;
        case 3:
            options.push(lockerAreas[0], lockerAreas[1], lockerAreas[2], lockerAreas[4], lockerAreas[5]);
            break;
        case 2:
            options = [...lockerAreas];
            break;
        case 1:
            options.push(lockerAreas[1], lockerAreas[2], lockerAreas[3]);
            break;
        default:
            break;
    }
    return options.map((val) => <option key={val} value={val}> {val}</option>);
};

export const renderOptionsWithoutCurrentArea = (areaSelect, lockerAreas, currentArea) => {
    let options = renderOptions(areaSelect, lockerAreas);
    return options.filter(option => option.key !== currentArea);
};